import { FC } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Button, Text } from '@frontend/design-system';

export interface TextWithButtonFieldProps {
  label: string;
  fieldKey: string;
  buttonLabel: string;
  buttonType: 'primary' | 'secondary';
  onButtonClick: () => void;
}

const containerStyles = css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(5)};
`;

const buttonWrapperStyles = css`
  flex: 1;
  white-space: nowrap;
  display: flex;
  justify-content: flex-end;
`;

export const TextWithButtonField: FC<TextWithButtonFieldProps> = ({
  label,
  fieldKey,
  buttonLabel,
  buttonType,
  onButtonClick,
}) => {
  return (
    <div css={containerStyles}>
      <Text>{label}</Text>
      <div css={buttonWrapperStyles}>
        <Button variant={buttonType} onClick={onButtonClick} type='button' trackingId={`${fieldKey}-button-action`}>
          {buttonLabel}
        </Button>
      </div>
    </div>
  );
};
